import { getBaseUrl } from '../../maps/apiEnvironmentMap';
import { EntryConfirmation } from '../microservices';

const API_KEY = process.env.REACT_APP_API_KEY;
export class EntryConfirmationRequestPOST {
  readonly method: string = 'operation/entry/confirmation';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }
  public generateContent(packageCandidateId: number, lockerPositionId: number) {
    const params = {
      packageCandidateId: packageCandidateId,
      lockerPositionId: lockerPositionId,
    };
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}
export type EntryConfirmationResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    entryConfirmation: EntryConfirmation;
    versionFails: number;
  };
};
